import React from 'react';

import {
  Flex,
  Skeleton,
  SkeletonCircle,
  SkeletonText,
  VStack,
} from '@chakra-ui/react';

import style from './styles/MainArticleSkeleton.style';

export const MainArticleSkeleton = () => {
  return (
    <Flex sx={style.root}>
      <Skeleton className="mainArticleSkeleton" />

      <VStack className="mainArticleVStack">
        <SkeletonText
          className="mainArticleSkeletonText1"
          skeletonHeight="13"
        />
        <SkeletonText className="mainArticleSkeletonText2" skeletonHeight="3" />
        <SkeletonText className="mainArticleSkeletonText2" skeletonHeight="3" />
        <SkeletonText className="mainArticleSkeletonText3" skeletonHeight="3" />
        <SkeletonCircle className="mainArticleSkeletonCircle" />
      </VStack>
    </Flex>
  );
};
